var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 22H9.8C13 22 15 20 15 16.8L15 12.75H8.75C8.34 12.75 8 12.41 8 12C8 11.59 8.34 11.25 8.75 11.25H15V7.2C15 4 13 2 9.8 2H7.21C4.01 2 2.01 4 2.01 7.2L2.01 16.8C2 20 4 22 7.2 22Z",
    fill: "#677481"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4396 12.7502L17.3696 14.8202C17.2196 14.9702 17.1496 15.1602 17.1496 15.3502C17.1496 15.5402 17.2196 15.7402 17.3696 15.8802C17.6596 16.1702 18.1396 16.1702 18.4296 15.8802L21.7796 12.5302C22.0696 12.2402 22.0696 11.7602 21.7796 11.4702L18.4296 8.12015C18.1396 7.83015 17.6596 7.83015 17.3696 8.12015C17.0796 8.41015 17.0796 8.89016 17.3696 9.18016L19.4396 11.2502H14.9996V12.7502H19.4396Z",
    fill: "#677481"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/SignOut.9abd38dbfbc6ffb14979a76850940e75.svg";
export { ForwardRef as ReactComponent };